module.exports = __webpack_public_path__ + "media/images/Consistency-Champ-173f88226af30bf36970b3c27fff921f.svg";